import React from 'react';

function ActivityIndicator () {
  return (
    <div className="s360-activity-indicator-container">
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  );
}

export default ActivityIndicator;
